var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJimorrowlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1157 148",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(200,0,0,200,-2.55176,144.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.02,-0.276L0.038,-0.276C0.038,-0.202 0.064,-0.139 0.116,-0.087C0.169,-0.035 0.232,-0.009 0.305,-0.009C0.378,-0.009 0.441,-0.035 0.493,-0.087C0.546,-0.139 0.572,-0.202 0.572,-0.276L0.572,-0.705L0.59,-0.705L0.59,-0.276C0.59,-0.197 0.562,-0.13 0.506,-0.074C0.451,-0.019 0.384,0.009 0.305,0.009C0.226,0.009 0.159,-0.019 0.104,-0.074C0.048,-0.13 0.02,-0.197 0.02,-0.276Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(200,0,0,200,143.425,144.226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.05,
    y: -0.705,
    width: 0.018,
    height: 0.705,
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(200,0,0,200,188.913,144.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.747,-0L0.729,-0L0.729,-0.674L0.426,-0.021C0.419,-0.007 0.409,-0 0.394,-0C0.379,-0 0.368,-0.007 0.361,-0.021L0.058,-0.674L0.058,-0L0.04,-0L0.04,-0.705L0.064,-0.705L0.377,-0.029C0.38,-0.021 0.385,-0.018 0.393,-0.018C0.4,-0.018 0.406,-0.021 0.41,-0.029L0.723,-0.705L0.747,-0.705L0.747,-0Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(200,0,0,200,366.237,144.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126,-0.608C0.197,-0.679 0.282,-0.714 0.381,-0.714C0.481,-0.714 0.566,-0.679 0.637,-0.608C0.708,-0.537 0.743,-0.452 0.743,-0.353C0.743,-0.253 0.708,-0.168 0.637,-0.097C0.566,-0.027 0.481,0.009 0.381,0.009C0.282,0.009 0.197,-0.027 0.126,-0.097C0.055,-0.168 0.02,-0.253 0.02,-0.353C0.02,-0.452 0.055,-0.537 0.126,-0.608ZM0.625,-0.595C0.557,-0.662 0.476,-0.696 0.381,-0.696C0.286,-0.696 0.205,-0.662 0.138,-0.595C0.072,-0.528 0.038,-0.447 0.038,-0.352C0.038,-0.257 0.072,-0.176 0.138,-0.109C0.205,-0.042 0.286,-0.009 0.381,-0.009C0.476,-0.009 0.557,-0.042 0.624,-0.109C0.691,-0.176 0.725,-0.257 0.725,-0.352C0.725,-0.447 0.692,-0.528 0.625,-0.595Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(200,0,0,200,538.776,144.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.058,-0L0.04,-0L0.04,-0.669C0.04,-0.679 0.044,-0.688 0.051,-0.695C0.058,-0.702 0.066,-0.705 0.075,-0.705L0.301,-0.705C0.36,-0.705 0.411,-0.684 0.453,-0.642C0.495,-0.599 0.516,-0.548 0.516,-0.489C0.516,-0.43 0.495,-0.379 0.453,-0.336C0.411,-0.294 0.36,-0.273 0.301,-0.273L0.103,-0.273C0.1,-0.273 0.098,-0.272 0.098,-0.269C0.098,-0.266 0.1,-0.264 0.103,-0.262L0.505,-0.016L0.495,-0L0.093,-0.246C0.084,-0.252 0.08,-0.259 0.08,-0.267C0.08,-0.274 0.082,-0.28 0.086,-0.285C0.091,-0.289 0.096,-0.291 0.103,-0.291L0.301,-0.291C0.355,-0.291 0.402,-0.31 0.44,-0.349C0.479,-0.388 0.498,-0.434 0.498,-0.489C0.498,-0.544 0.479,-0.59 0.44,-0.629C0.402,-0.668 0.355,-0.687 0.301,-0.687L0.075,-0.687C0.071,-0.687 0.067,-0.685 0.063,-0.681C0.06,-0.678 0.058,-0.674 0.058,-0.669L0.058,-0Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(200,0,0,200,661.901,144.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.058,-0L0.04,-0L0.04,-0.669C0.04,-0.679 0.044,-0.688 0.051,-0.695C0.058,-0.702 0.066,-0.705 0.075,-0.705L0.301,-0.705C0.36,-0.705 0.411,-0.684 0.453,-0.642C0.495,-0.599 0.516,-0.548 0.516,-0.489C0.516,-0.43 0.495,-0.379 0.453,-0.336C0.411,-0.294 0.36,-0.273 0.301,-0.273L0.103,-0.273C0.1,-0.273 0.098,-0.272 0.098,-0.269C0.098,-0.266 0.1,-0.264 0.103,-0.262L0.505,-0.016L0.495,-0L0.093,-0.246C0.084,-0.252 0.08,-0.259 0.08,-0.267C0.08,-0.274 0.082,-0.28 0.086,-0.285C0.091,-0.289 0.096,-0.291 0.103,-0.291L0.301,-0.291C0.355,-0.291 0.402,-0.31 0.44,-0.349C0.479,-0.388 0.498,-0.434 0.498,-0.489C0.498,-0.544 0.479,-0.59 0.44,-0.629C0.402,-0.668 0.355,-0.687 0.301,-0.687L0.075,-0.687C0.071,-0.687 0.067,-0.685 0.063,-0.681C0.06,-0.678 0.058,-0.674 0.058,-0.669L0.058,-0Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(200,0,0,200,785.026,144.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.126,-0.608C0.197,-0.679 0.282,-0.714 0.381,-0.714C0.481,-0.714 0.566,-0.679 0.637,-0.608C0.708,-0.537 0.743,-0.452 0.743,-0.353C0.743,-0.253 0.708,-0.168 0.637,-0.097C0.566,-0.027 0.481,0.009 0.381,0.009C0.282,0.009 0.197,-0.027 0.126,-0.097C0.055,-0.168 0.02,-0.253 0.02,-0.353C0.02,-0.452 0.055,-0.537 0.126,-0.608ZM0.625,-0.595C0.557,-0.662 0.476,-0.696 0.381,-0.696C0.286,-0.696 0.205,-0.662 0.138,-0.595C0.072,-0.528 0.038,-0.447 0.038,-0.352C0.038,-0.257 0.072,-0.176 0.138,-0.109C0.205,-0.042 0.286,-0.009 0.381,-0.009C0.476,-0.009 0.557,-0.042 0.624,-0.109C0.691,-0.176 0.725,-0.257 0.725,-0.352C0.725,-0.447 0.692,-0.528 0.625,-0.595Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(200,0,0,200,947.604,144.226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.52,-0.472C0.533,-0.472 0.543,-0.465 0.549,-0.45L0.722,-0.028C0.725,-0.02 0.73,-0.017 0.735,-0.017C0.74,-0.017 0.744,-0.02 0.748,-0.028L1.018,-0.705L1.037,-0.705L0.764,-0.022C0.759,-0.007 0.749,0.001 0.735,0.001C0.722,0.001 0.712,-0.006 0.706,-0.021L0.533,-0.444C0.531,-0.451 0.526,-0.454 0.521,-0.454C0.515,-0.454 0.51,-0.451 0.508,-0.444L0.336,-0.021C0.33,-0.006 0.32,0.001 0.307,0.001C0.302,0.001 0.296,-0.001 0.291,-0.006C0.285,-0.011 0.28,-0.016 0.278,-0.022L0.005,-0.705L0.023,-0.705L0.294,-0.028C0.297,-0.02 0.302,-0.017 0.307,-0.017C0.312,-0.017 0.317,-0.021 0.32,-0.028L0.492,-0.45C0.495,-0.456 0.499,-0.461 0.504,-0.466C0.51,-0.47 0.515,-0.472 0.52,-0.472Z",
    style: {
      fillRule: "nonzero",
      stroke: "black",
      strokeWidth: "0.01px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJimorrowlogo);
export default __webpack_public_path__ + "static/media/jimorrow logo.f16d5da3a5c17bc0c6f9bd6a318e4acc.svg";
export { ForwardRef as ReactComponent };